import { StoplightProject } from "@stoplight/elements-dev-portal";
import "@stoplight/elements-dev-portal/styles.min.css";
import "./Capturativos.css"

function Capturativos() {
  return (
    <div className="container">
      <StoplightProject projectId="cHJqOjI3MDk0Nw" router="hash" />
    </div>
  );
}

export default Capturativos;
